// Carousel component
const Carousel = (identity, options) => {
    // Initializing Carousel
    return new Swiper(identity, options);
};

// Export component
export default Carousel;